export async function setOrganizationPermission(organization: string): Promise<void> {
  const response = await fetch("/api/v1/user-permissions/set-organizations", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ organization }),
  });

  if (!response.ok) {
    throw new Error("Failed to set organization permission");
  }
}